// extracted by mini-css-extract-plugin
export default {"container":"Incrementdecrementer_container__9JjQV","counter_input":"Incrementdecrementer_counter_input__GfmGn"};